export const INSTITUTION_CODE = {
  HASC: 'HASC',
  NHG: 'NHG',
  NHGP: 'NHGP',
  NSC: 'NSC',
  NUHS: 'NUHS',
  NUP: 'NUP',
};

export const APPT_PROCESS = {
  MAKE_NEW: 'MakeNew',
  RESCHEDULE: 'Reschedule',
};

export const TRANSACTION_TYPE = {
  HEALTHPLAN_DISCUSSION: 'HPD',
};
